var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"pt16 pb16"},[_c('base-alert',[_c('i',{staticClass:"el-icon-warning"}),_vm._v(" "),_c('b',[_vm._v("图片查重提示：")]),_vm._v("\n    *标记任务记录内提交的图片存在重复，请注意查看\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }